import { Component, EventEmitter, Output } from '@angular/core';
import { TrapFocusDirective } from '@shared/directives/trap-focus.directive';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-menu-support[closePopover]',
    templateUrl: './menu-support.component.html',
    styleUrls: ['./menu-support.component.scss'],
    standalone: true,
    imports: [TrapFocusDirective, TranslateModule],
})
export class MenuSupportComponent {
    @Output() closePopover: EventEmitter<void> = new EventEmitter<void>();

    readonly supportHubUrl = 'https://www.transnetyx.com/support';
    readonly termsOfUseUrl = 'https://info.transnetyx.com/hubfs/Transnetyx%20Terms%20of%20Use.pdf';

    close(): void {
        this.closePopover.emit();
    }

    openChat(): void {
        // @ts-ignore
        window['happyFoxChat'].showWidget();
        // @ts-ignore
        window['happyFoxChat'].expandChatbox();
        this.close();
    }
}
